import { memo, useEffect, useState } from "react";
import { Button, Card, Col, Form, Image, Row } from "react-bootstrap"
import { HAI_SAN_PRIORITY_DEFAULT, PLAYER_CONFIG, PLAYER_CONFIG_IMAGE, PLAYER_CONFIG_LABEL, PLAYER_CONFIG_SEAFOOD, PLAYER_CONFIG_TIP } from "../../constants/Common";
import MoleculeImageInputNumber from "../../Molecule/MoleculeImageInputNumber";
import usePlayerConfig from "../../hooks/usePlayerConfig";
import { configPlayer } from "../../services/authService";
import useSettingScreen from "../../hooks/useSettingScreen";
import { SCREEN_SETTING } from "../../constants/screenRouter";
import MoleculeCheckBox from "../../Molecule/MoleculeCheckBox";
import useOnlineInfo from "../../hooks/useOnlineInfo";

const SettingSeaFood = ({ playerId }) => {
    const [newConfig, setNewConfig] = useState({})
    const { configs, updateSingleConfig } = usePlayerConfig(playerId)
    const { gotoScreen } = useSettingScreen(playerId);
    const { online } = useOnlineInfo(playerId);


    const handleSubmit = (e) => {
        e.preventDefault();
        configPlayer(playerId, newConfig);
        gotoScreen(playerId, SCREEN_SETTING.NO_OPEN);

    }

    const updateNewConfig = (configId, value) => {
        if (PLAYER_CONFIG_SEAFOOD.includes(configId) <= 0
            && PLAYER_CONFIG.ID_IS_FARM_HAI_SAN_RESET != configId
            && PLAYER_CONFIG.ID_PRIORITY_HAI_SAN != configId) return;
        // console.log('updateNewConfig', playerId, configId, value);
        setNewConfig(
            prevConfig => ({
                ...prevConfig,
                [configId]: value
            }))
    }
    const updateNewPriority = (configId, value) => {
        const defaultPriority = [...newConfig[PLAYER_CONFIG.ID_PRIORITY_HAI_SAN]]
        // console.log('updateNewPriority 1', defaultPriority);
        const newIndex = value;
        const oldIndex = defaultPriority.indexOf(configId);
        // console.log('updateNewPriority 2', oldIndex, '->', newIndex);
        if (oldIndex >= 0 && newIndex >= 0 && newIndex < defaultPriority.length) {
            defaultPriority.splice(oldIndex, 1); // Xóa giá trị khỏi vị trí cũ

            // console.log('updateNewPriority 3', defaultPriority);
            defaultPriority.splice(newIndex, 0, configId); // Chèn giá trị vào vị trí mới
            // console.log('updateNewPriority 4', defaultPriority);
            updateNewConfig(PLAYER_CONFIG.ID_PRIORITY_HAI_SAN, defaultPriority);
        }
        else {
            updateNewConfig(PLAYER_CONFIG.ID_PRIORITY_HAI_SAN, [...HAI_SAN_PRIORITY_DEFAULT]);
        }

    }

    useEffect(() => {
        for (const id in configs) {
            const configId = Number(id);
            if (configId == PLAYER_CONFIG.ID_PRIORITY_HAI_SAN) {
                if ((configs[configId] instanceof Array)) {
                    const cpPriority = [...configs[configId]]
                    updateNewConfig(configId, cpPriority);
                }
            }
            else if (PLAYER_CONFIG_SEAFOOD.includes(configId) == true || PLAYER_CONFIG.ID_IS_FARM_HAI_SAN_RESET == configId) {
                // console.log('SettingSeaFood', playerId, configId, configs[configId])
                updateNewConfig(configId, configs[configId]);
            }

        }
    }, [configs])

    useEffect(() => {
        if (online == false) {
            gotoScreen(playerId, SCREEN_SETTING.NO_OPEN);
        }
    }, [online])

    return (
        <Card.Body>
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col>
                        <Row className="mb-2">
                            <MoleculeCheckBox
                                key={PLAYER_CONFIG.ID_IS_FARM_HAI_SAN_RESET}
                                label={PLAYER_CONFIG_LABEL[PLAYER_CONFIG.ID_IS_FARM_HAI_SAN_RESET]}
                                tooltip={PLAYER_CONFIG_TIP[PLAYER_CONFIG.ID_IS_FARM_HAI_SAN_RESET]}
                                value={newConfig[PLAYER_CONFIG.ID_IS_FARM_HAI_SAN_RESET]}
                                onChange={(newValue) => { updateNewConfig(PLAYER_CONFIG.ID_IS_FARM_HAI_SAN_RESET, newValue) }}
                            />
                        </Row>
                        <Row xs={2} sm={3} md={4} lg={6}>
                            {
                                PLAYER_CONFIG_SEAFOOD.map(configId => (
                                    <MoleculeImageInputNumber
                                        key={configId}
                                        img={PLAYER_CONFIG_IMAGE[configId]}
                                        priority={
                                            newConfig[PLAYER_CONFIG.ID_PRIORITY_HAI_SAN] instanceof Array ? newConfig[PLAYER_CONFIG.ID_PRIORITY_HAI_SAN].indexOf(configId) : HAI_SAN_PRIORITY_DEFAULT.indexOf(configId)}
                                        value={newConfig[configId]}
                                        cbOnChange={newValue => updateNewConfig(configId, newValue)}
                                        cbOnChangePriority={newValue => updateNewPriority(configId, newValue)}
                                    />
                                ))
                            }
                        </Row>
                    </Col>
                    <Col xs={2} sm={2} md={1} lg={1} className="d-flex align-items-center">
                        <Row><Button className="mx-auto" variant="outline-primary" type="submit">Save</Button></Row>
                    </Col>
                </Row>
            </Form>
        </Card.Body>
    );
}

export default memo(SettingSeaFood)